import type { BannerSeverity, ServiceStatus } from "@/client-types/service-status";

const SEVERITIES: BannerSeverity[] = ["outage", "maintenance", "info"];

function isSeverity(value: unknown): value is BannerSeverity {
  return SEVERITIES.includes(value as BannerSeverity);
}

/**
 * Validates status.json, which is hand-edited from a phone during an outage and therefore has to be
 * treated as untrusted input. Anything that does not match the contract yields null, which the
 * banner reads as "no message" — a malformed file must never break the client.
 */
export function parseServiceStatus(raw: unknown): ServiceStatus | null {
  if (typeof raw !== "object" || raw === null || Array.isArray(raw)) return null;

  const { active, severity, title, message, updatedAt } = raw as Record<string, unknown>;

  if (typeof active !== "boolean") return null;
  if (!isSeverity(severity)) return null;
  if (typeof title !== "string") return null;
  if (typeof message !== "string") return null;
  if (updatedAt !== undefined && typeof updatedAt !== "string") return null;

  const trimmedUpdatedAt = updatedAt?.trim();

  return {
    active,
    severity,
    title,
    message,
    ...(trimmedUpdatedAt ? { updatedAt: trimmedUpdatedAt } : {}),
  };
}
